import template from './drug-depletions-interactions.html';
export var DrugDepletionsInteractionsComponent = {
    template: template,
    controller: /** @class */ (function () {
        function DrugDepletionsInteractionsComponent($sce, EducationSubNavService) {
            'ngInject';
            this.headerContent = 'A to Z Index of Drug Interactions with Vitamins, Herbs and Foods';
            this.subHeaderContent = 'Click a topic for more information.';
            this.selectedpageindex = 6;
            this.level = '2';
            this.eduSubNavService = EducationSubNavService;
            this.eduSubNavService.level = '2';
            this.frameUrl = $sce.trustAsResourceUrl('/api/education/clinical-resources-subpage?page=drug-depletions');
        }
        return DrugDepletionsInteractionsComponent;
    }())
};
//# sourceMappingURL=drug-depletions-interactions.component.js.map